import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, filter, finalize, switchMap, take } from 'rxjs/operators';
import { LoaderService } from './loader.service';
import { NavigationExtras, Router } from '@angular/router';
import { ToastrManager, ToastrModule } from 'ng6-toastr-notifications';
import { JwtService } from './jwt.service';
import { UserType } from 'src/app/shared/Constants/user-type';
import { AuthService } from './auth.service';
import { error } from 'console';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  Utype: any;
  constructor(private loaderService: LoaderService,
    private router: Router,private toaster : ToastrManager,
    private jwtService : JwtService,private authService:AuthService
    ) {this.Utype =UserType;}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      const excludedTokenAPIs = ["api/ISDPToken/refresh", "api/ISDPToken"];
      const shouldCheckToken = !excludedTokenAPIs.some(api => request.url.includes(api));

      if (shouldCheckToken && this.authService.isTokenExpired()) {
        // this.authService.goToHome();
        // return of();
        //this.authService.logout();
        // const token = this.authService.getToken();
        // if (token && token != "") {
        //   return this.authService.refreshAccessToken().pipe(
        //     switchMap(() => next.handle(this.addTokenToRequest(request))),
        //     catchError((error: HttpErrorResponse) => {
        //       this.handleError(error);
        //       return throwError(() => error);
        //     }),
        //     // TODO: Loader hide is not required here since it is managed inside ap.service file
        //     finalize(() => this.loaderService.showLoader(false))
        //   );
        // }
      }

      return next.handle(this.addTokenToRequest(request)).pipe(
        catchError((error: HttpErrorResponse) => {
          this.handleError(error);
          return throwError(() => error);
        }),
        // TODO: Loader hide is not required here since it is managed inside ap.service file
        finalize(() =>  {}
        ));
    }


// private addTokenToRequest(request: HttpRequest<any>): HttpRequest<any> {

//     const user = localStorage.getItem('selectedClientId');
//     return user != null ? request.clone({
//         setHeaders: {
//             'X-Client-Id': user
//         }
//     }) : request.clone();
// }
private addTokenToRequest(request: HttpRequest<any>): HttpRequest<any> {
  const selectedClientId = localStorage.getItem('selectedClientId');
  const selectedSClientId = localStorage.getItem('supplierClientId');
  const loginUser = localStorage.getItem('LoginUser');

  let headers: { [key: string]: string } = {};

  // Add headers conditionally based on user type
  if (loginUser && loginUser === UserType.Supplier) {
     if (!selectedSClientId) {
        return request;
      }
      headers['X-SClient-Id'] = selectedSClientId;
    } else {
    if (!selectedClientId) {
      return request;
     }
      headers['X-Client-Id'] = selectedClientId;
  }

  // Clone the request with the additional headers
  return request.clone({ setHeaders: headers });
}


  handleError(error:any){
    // console.log('HTTP Error occurred:');
    // console.log('Status:', error.status);
    // console.log('Status Text:', error.statusText);
    // console.log('URL:', error.url);
    // console.log('Error Body:', error.error);
    // console.log('Message:', error.message);
    // console.log('Name:', error.name);
    // console.log('Headers:', error.headers);
    // console.log('ok:', error.ok);
    const navigationExtras: NavigationExtras = {
      queryParams: {
        status: error.status
      }
    };
    if (process['env']['NODE_ENV'] === 'dev') {
      switch (error.status) {
        case 0:
          this.toaster.errorToastr(`Error Code: ${error.status}\nMessage: ${error.message}`, "", "top-right");
          this.router.navigate(['/error'], navigationExtras);
          break;
        case 401:
        case 403:
        case 404:
        case 503:
        case 400:
          this.router.navigate(['/error'], navigationExtras);
          break;
        default:
          this.router.navigate(['/error'], navigationExtras);
          break;
      }
    }
    else{
      switch (error.status) {
        case 401:
        case 403:
        case 404:
        case 503:
        case 400:
          case 0:
            //this.authService.goToHome();
            this.router.navigate(['/error'], navigationExtras);
          break;
        default:
          this.router.navigate(['/error'], navigationExtras);
          break;
      }
    }
  }
}
